import { types } from "../types";

const initialState = {
  proposals: [],

  proposalToUpdate: null,
  proposalToDelete: null,
  proposalStudentName: null,

  proposalUpdated: null,
  proposalCreated: null,

  studentselected: null,
  addingStudent: false,

  coursesSelected: [],
  addingCourses: false,
  updatingCourse: false,
  courseToUpdate: null,

  visa: [],
  addingVisa: false,
  updatingVisa: false,
  visaToUpdate: null,

  insurance: [],
  addingInsurance: false,
  updatingInsurance: false,
  insuranceToUpdate: null,

  note: null,
  addingNote: false,
  updatingNote: false,
  noteToUpdate: null,
};

export const proposalReducer = (state = initialState, action) => {
  switch (action.type) {
    //CRUD
    case types.getProposal:
      return {
        ...state,
        proposals: action.payload,
      };

    case types.createProposal:
      return {
        ...state,
        proposals: [action.payload, ...state.proposals],
      };

    case types.deleteProposal:
      return {
        ...state,
        proposals: state.proposals.filter(
          (proposal) => proposal._id !== action.payload
        ),
      };

    case types.updateProposal:
      return {
        ...state,
        proposals: state.proposals.map((proposal) =>
          proposal._id === action.payload._id ? action.payload : proposal
        ),
      };

    //Process

    case types.setProposalCreated:
      return {
        ...state,
        proposalCreated: action.payload,
      };

    case types.removeProposalCreated:
      return {
        ...state,
        proposalCreated: null,
      };

    case types.setProposalToUpdate:
      // console.log(action.payload, "reducer");
      return {
        ...state,
        proposalToUpdate: action.payload,

        studentselected: action.payload.studentSelected,
        coursesSelected: action.payload.coursesSelected,
        visa: action.payload.visaSelected,
        insurance: action.payload.insuranceSelected,
        note: action.payload.noteSelected,
      };

      case types.setProposalUpdated:
        return {
          ...state,
          proposalUpdated: action.payload,
        };
      case types.removeProposalUpdated:
        return {
          ...state,
          proposalUpdated: null
        };


    case types.removeProposalfromUpdate:
      return {
        ...state,
        proposalToUpdate: null,
      };

    case types.setProposalToDelete:
      return {
        ...state,
        proposalToDelete: action.payload,
        proposalStudentName: state.proposals.filter((proposal) =>
          proposal._id === action.payload ? proposal : null
        ),
      };

    case types.setSelectedStudent:
      return {
        ...state,
        studentselected: action.payload,
        addingStudent: false,
      };

    case types.removeSelectedStudent:
      return {
        ...state,
        studentselected: null,
      };
    // Courses-process
    case types.setSelectedCourse:
      return {
        ...state,
        coursesSelected: [...state.coursesSelected, action.payload],
      };

    case types.removeSelectedCourse:
      return {
        ...state,
        coursesSelected: state.coursesSelected.filter(
          (course) => course._id !== action.payload
        ),
      };

    case types.setCourseToUpdateInProposal:
      return {
        ...state,
        courseToUpdate: action.payload,
      };

    case types.updateCourseSelected:
      return {
        ...state,
        coursesSelected: state.coursesSelected.map((course) =>
          course._id === action.payload._id ? action.payload : course
        ),
      };

    case types.clearSelectedCourses:
      return {
        ...state,
        coursesSelected: [],
      };

    // Visa-process

    case types.setSelectedVisa:
      return {
        ...state,
        visa: [...state.visa, action.payload],
      };

    case types.removeSelectedVisa:
      return {
        ...state,
        visa: state.visa.filter((visa) => visa._id !== action.payload),
      };

    case types.setVisaToUpdateInProposal:
      return {
        ...state,
        visaToUpdate: action.payload,
      };
    case types.updateVisaSelected:
      return {
        ...state,
        visa: state.visa.map((visa) =>
          visa._id === action.payload._id ? action.payload : visa
        ),
      };
    case types.clearSelectedVisas:
      return {
        ...state,
        visa: [],
      };
    // Insurance-process
    case types.setSelectedInsurance:
      return {
        ...state,
        insurance: [...state.insurance, action.payload],
      };

    case types.removeSelectedInsurance:
      return {
        ...state,
        insurance: state.insurance.filter(
          (insurance) => insurance._id !== action.payload
        ),
      };
    case types.setInsuranceToUpdateInProposal:
      return {
        ...state,
        insuranceToUpdate: action.payload,
      };

    case types.updateInsuranceSelected:
      return {
        ...state,
        insurance: state.insurance.map((insurance) =>
          insurance._id === action.payload._id ? action.payload : insurance
        ),
      };

    case types.clearSelectedInsurance:
      return {
        ...state,
        insurance: [],
      };
    //Note-Process

    case types.setSelectedNote:
      return {
        ...state,
        note: action.payload,
      };
    case types.removeSelectedNote:
      return {
        ...state,
        note: null,
      };
    case types.setNoteToUpdateInProposal:
      return {
        ...state,
        noteToUpdate: action.payload,
      };
    case types.updateNoteSelected:
      return {
        ...state,
        note: action.payload,
      };

    //Side Actions//
    case types.addingStudent:
      return {
        ...state,
        addingStudent: true,
      };

    case types.removingStudent:
      return {
        ...state,
        addingStudent: false,
      };
    // --Courses--
    case types.addingCourses:
      return {
        ...state,
        addingCourses: true,
      };

    case types.removingCourses:
      return {
        ...state,
        addingCourses: false,
      };

    case types.updatingCourseInProposal:
      return {
        ...state,
        updatingCourse: true,
      };

    case types.removeUpdatingCourseInProposal:
      return {
        ...state,
        updatingCourse: false,
        courseToUpdate: null,
      };

    //--visa--

    case types.addingVisa:
      return {
        ...state,
        addingVisa: true,
      };

    case types.removingVisa:
      return {
        ...state,
        addingVisa: false,
      };
    case types.updatingVisaInProposal:
      return {
        ...state,
        updatingVisa: true,
      };
    case types.removeUpdatingVisaInProposal:
      return {
        ...state,
        updatingVisa: false,
        visaToUpdate: null,
      };

    //Insurance Side action

    case types.addingInsurance:
      return {
        ...state,
        addingInsurance: true,
      };

    case types.removingInsurance:
      return {
        ...state,
        addingInsurance: false,
      };

    case types.updatingInsuranceInProposal:
      return {
        ...state,
        updatingInsurance: true,
      };
    case types.removeupdatingInsuranceInProposal:
      return {
        ...state,
        updatingInsurance: false,
        insuranceToUpdate: null,
      };

    // Note Actions
    case types.addingNote:
      return {
        ...state,
        addingNote: true,
      };

    case types.removingNote:
      return {
        ...state,
        addingNote: false,
      };
    case types.updatingNoteInProposal:
      return {
        ...state,
        updatingNote: true,
      };
    case types.removeUpdatingNoteInProposal:
      return {
        ...state,
        updatingNote: false,
        noteToUpdate: null,
      };
    default:
      return state;
  }
};
